import type { GetPrizesElementResponseType } from "@jti/rest-api-types";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";

const DISCOVER_MORE_CTA_NAME = "discover-more";
const DISCOVER_MORE_CTA_LOCATION = "reward-redemption";

type TrackRewardDiscoverMoreClickParams = {
  name?: GetPrizesElementResponseType["name"];
  prize_uuid?: GetPrizesElementResponseType["prize_uuid"];
  locations?: GetPrizesElementResponseType["locations"] | null;
};

export const trackRewardDiscoverMoreClick = ({
  name,
  prize_uuid: rewardUuid,
  locations,
}: TrackRewardDiscoverMoreClickParams) => {
  return dispatchTrackingEvent(TrackingEvents.TrackingRewardDiscoverMoreClick, {
    reward: name ?? "",
    reward_uuid: rewardUuid ?? "",
    sensory_experience: !!locations?.length,
    cta_name: DISCOVER_MORE_CTA_NAME,
    cta_location: DISCOVER_MORE_CTA_LOCATION,
  });
};
